import { NotepadTextIcon } from 'lucide-react';

import { Button, HoverCard, HoverCardContent, HoverCardTrigger, Text } from '@/_components';

export function NotesHoverCard({ text }: { text: string | null | undefined }) {
  if (!text) {
    return <Text className="text-accent-light dark:text-accent-x-light text-center text-sm font-normal">—</Text>;
  }

  return (
    <HoverCard openDelay={150} closeDelay={150}>
      <HoverCardTrigger className="cursor-pointer">
        <Button
          icon={NotepadTextIcon}
          tag="div"
          size="sm"
          as="link"
          aria-label="Notes"
          className={
            'text-accent-light dark:text-accent-x-light m-auto text-sm font-normal opacity-40 hover:opacity-100'
          }
        />
      </HoverCardTrigger>
      <HoverCardContent side="top" className="flex w-72 flex-col items-start justify-start px-4 py-5">
        <Text className="text-accent text-left font-semibold dark:text-white">Notes</Text>
        {text}
      </HoverCardContent>
    </HoverCard>
  );
}
